import styled from 'styled-components';
import MobileTopNavSmallView from '../MobileTopNav/MobileTopNavSmallView';

// eslint-disable-next-line
export const StyledMobileTopNavSmallView = styled(MobileTopNavSmallView)`
  box-shadow: none;
  background: #fff;

  .mobile-top-nav-small-text {
    width: 70% !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: 0 auto;
    font-size: ${props => (props.smallFont ? '18px' : '24px')};
  }
`;
